import React, { useState, useRef, useContext, useEffect } from 'react';
import '../../../assets/css/views/recargas.css'
import { Modal } from '../../components/modal/Modal'
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { useUsuariosAplicativo } from '../../../hooks/useUsuariosAplicativo';
import { formatDate, notify, soloDecimal, formatState, formatoNombre,soloCelular,soloNumero } from '../../../utils/utils'
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { Tooltip } from '../../components/utils/Tooltip';
import { useAmonestaciones } from '../../../hooks/useAmonestaciones';
import { ModalRecarga } from '../../components/modal/ModalRecarga';
import { SearchTable } from '../../components/utils/SearchTable';
import { useModal } from '../../../hooks/useModal';

export const UsuariosAplicativo = () => {
    const {
        usuarios,
        listarUsuarios,
        setUsuario,
        usuario,
        editarValorUsuario,
        obtenerUsuario,
        spinner,
        openModal,
        isOpen,
        closeModal,
        anularUsuario,
        editarValorAnularUsuario,
        usuarioAnular,
        removerRolUsuario
    } =  useUsuariosAplicativo();
    const {
        listarAmonestaciones,
        amonestaciones,
        RegistrarAmonestacion,
        editarValorAmonestacion,
        isOpenModalAmonestaciones,
        openModalAmonestaciones,
        closeModalAmonestaciones,
        bloqueos,
        listarBloqueos,
        isOpenModalBloqueos,
        closeModalBloqueos,
        registrarUsuarioEstado,
        amonestacion
    } = useAmonestaciones();

    const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const [status, setStatus] = useState(1)
    const idTablaUsuarios = "idTablaUsuarios";

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [ isOpenModalAnularUsuario, openModalAnularUsuario, closeModalAnularUsuario ] = useModal();
    const [ tipoUsuario, setTipoUsuario ] = useState("beex-mobile")
    const [ valorFiltro, setValorFiltro ] = useState("")
    const UserType = [
        {scope: "beex-mobile", name: "Todos"},
        {scope: "beex-manager-profileuser", name: "Admin"},
        {scope: "beex-manager-recharger", name: "Recargador"},
        {scope: "beex-manager-unitlinkerqr", name: "Enlazador"},
    ]

    const recargasFiltro = usuarios
    ?.filter((objeto) => {
        // Object.values(objeto) devuelve un array con solo los valores: ["001", "asdad", ...]
        return Object.values(objeto).some((valor) => 
            String(valor).toLowerCase().includes(valorFiltro.toLocaleLowerCase())
        );
    })
    const usersToDisplay = recargasFiltro?.slice(indexOfFirstItem, indexOfLastItem);



    useEffect(()=>{
        listarUsuarios(tipoUsuario)
    },[tipoUsuario])
        
    const totalPages = Math.ceil(recargasFiltro.length / itemsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const pageNumbers = [];
    
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const cantidadAmonestaciones = 0

    const formatoFecha  = (fechaAntigua) => {
        // let partes = fechaAntigua.split(' ');
        // let fechaSinZonaHoraria = partes.slice(0, 4).join(' ');
        let fecha = new Date(fechaAntigua);

        let dia = fecha.getDate().toString().padStart(2,'0');
        let mes = (fecha.getMonth() + 1).toString().padStart(2,'0');
        let anio = fecha.getFullYear();

        let horas = fecha.getHours().toString().padStart(2, '0');
        let minutos = fecha.getMinutes().toString().padStart(2, '0');
        let segundos = fecha.getSeconds().toString().padStart(2, '0');

        return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }

    const registrarAnularUsuario = async() => {
        const isValid = tipoUsuario === "beex-mobile" ? await anularUsuario() : await removerRolUsuario(UserType.find(u => u.scope === tipoUsuario).scope);
        if(isValid){
            listarUsuarios();
            closeModalAnularUsuario();
        }
    }


    return (
        <>
            <ContenedorParametros titulo='Usuarios Biix'>
                <i className={"fa-solid fa-user-group"} title={"Tipos de usuarios"}></i>
                <select
                    key={'select-tipo-usuario'}
                    className={' w-[150px] ' + classNameInput}
                    value={tipoUsuario}
                    onChange={(e) => setTipoUsuario(e.target.value)}
                >
                    {
                        UserType.map((data, i) => (
                            <option key={`${i}_option`} value={data.scope}>{data.name}</option>
                        ))
                    }
                </select>
                <BotonProcesar onClick={() => listarUsuarios(tipoUsuario)}></BotonProcesar>
                <SearchTable setValueFilter={setValorFiltro}></SearchTable>
            </ContenedorParametros>

             {/* CABECERA Y CUERPO */}
            <div className="containerScroll  max-h-[80%] mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id={idTablaUsuarios}  className="table">
                    <thead> 
                        <tr>
                            <th className="w-[40px] text-left">N</th>
                            <th className='text-left'>NOMBRE</th>
                            <th className='text-left'>USUARIO</th>
                            <th className='text-left'>DNI</th>
                            <th className='text-left'>CELULAR</th>                    
                            <th className='text-left'>FECHA CREACIÓN</th>
                            <th className="text-right w-[80px]">SALDO</th>
                            <th className="text-left w-[80px]">ESTADO</th>
                            <th className='w-[50px] text-left'></th>
                            <th className='w-[50px] text-left'></th>
                            <th className='w-[50px] text-left'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {   
                            usersToDisplay.length > 0 
                            ? usersToDisplay?.map((u, i) => {
                                let classNameBateria = ''
                                switch(cantidadAmonestaciones){
                                    case 0 : classNameBateria = 'fa fa-battery-full text-[20px] text-green-500';
                                        break;
                                    case 1 : classNameBateria = 'fa fa-battery-half text-[20px] text-yellow-500';
                                        break;
                                    case 2 : classNameBateria = 'fa fa-battery-quarter text-[20px] text-red-500';
                                        break;
                                    case 3 : classNameBateria = 'fa fa-battery-empty text-[20px] text-white';
                                        break;
                                    default : classNameBateria = 'fa fa-battery-empty text-[20px] text-green-500';
                                        break;
                                }
                                return (
                                    <tr key={u.uid}>
                                        <td className='text-left'>{++i}</td>
                                        <td className=''>{u.givenName} {u.apellidoPaterno} {u.apellidoMaterno}</td>
                                        <td className='text-left'>{u.cn}</td>
                                        <td>{u.dni || ''}</td>
                                        <td className='text-left'>{u.mobile || u.telephoneNumber || ''}</td>
                                        <td className='text-left'>{u.createdDate ? formatoFecha(u.createdDate) : ''}</td>
                                        <td className='text-right'>{u.saldo ?  `${u.saldo.toFixed(2)}` : ''}</td>
                                        <td className='text-center'>
                                            <span className='px-2 py-[2px] rounded-md bg-green-600'>Activo</span>
                                        </td>{/* estado */}
                                        <td className='text-center'>
                                            <i
                                                data-tip={`codUsuario-${u.uid}`}
                                                data-for={`codUsuario-${u.uid}`}
                                                className={`${classNameBateria}`}
                                            ></i>
                                            <Tooltip id={`codUsuario-${u.uid}`}>{`Cantidad de amonestaciones 0`}</Tooltip>
                                        </td>
                                        <td className='text-center'>
                                            <button
                                                data-tip='VerDatos'
                                                data-for='VerDatos'
                                                className="bg-black-500 bg-blue-600 text-[14px] px-[5px] py-1 rounded"
                                                onClick={() => {
                                                    setUsuario(u);
                                                    openModal();
                                                }}
                                            >
                                                <i className='fa fa-address-card'></i>
                                            </button>
                                            <Tooltip id='VerDatos'>{`Ver Datos`}</Tooltip>
                                        </td>
                                        <td>
                                            <button
                                                class="bg-red-600 text-white px-2 py-1 rounded-md"
                                                onClick={() => {
                                                    const [uid, ou] = u.uid.split(',');
                                                    const uidAnular = uid.split('=')[1]
                                                    editarValorAnularUsuario("motivoAnular", "");
                                                    editarValorAnularUsuario("uidAnular", uidAnular);
                                                    editarValorAnularUsuario("nomUsuarioAnular", (u.givenName || "") + " " + (u.apellidoPaterno || "") + " " + (u.apellidoMaterno || ""))
                                                    openModalAnularUsuario()
                                                }}
                                            >
                                                <i className='fa fa-trash-can'></i>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                    </tbody>
                </table>

            </div>
            <div className="pagination mt-3  p-1 ">
                <button
                    className="hover:bg-blue-500 rounded-full pagination-button px-2 "
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    >
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </button>
                {
                    pageNumbers.map((page) => (
                        <button
                            key={page}
                            className={`pagination-button rounded-[100%] w-[26px] h-[26px] mx-[1px]
                                ${page === currentPage ? 
                                    ' active bg-blue-500 '
                                    :
                                    '  bg-gray-800  hover:bg-blue-500 '
                                }`
                            }
                            onClick={() => handlePageChange(page)}
                        >
                        {page}
                        </button>
                    ))
                }
                <button
                    className="hover:bg-blue-500 rounded-full pagination-button px-2  "
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    >
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button>
            </div>
            





            <Modal 
                isOpen={isOpen} closeModal={closeModal} action={{}}
                title="Detalles Usuario"
                spinner={spinner}
                textButtons={{ denied: 'Cerrar' }}
                validButton={{ confirm: false, denied: true}}

            >
                <div className="px-5 grid grid-cols-[minmax(0,05fr)_minmax(0,15fr)_minmax(0,80fr)] gap-y-3 items-center">
                    <i className="fas fa-user"></i>    
                    <label>Nombre</label>
                    <input
                        className={`${classNameInput} caret-input`}
                        defaultValue={usuario.givenName}
                        onChange={(e) => editarValorUsuario("nomPersona", e.target.value)}
                        disabled
                    />
                    <i className="fas fa-user"></i>
                    <label>Usuario</label>
                    <input
                        className={`${classNameInput} caret-input`}
                        defaultValue={usuario.cn}
                        onChange={(e) => editarValorUsuario("nomUsuario", e.target.value)}
                        disabled
                    />
                    <i class="fa-solid fa-at"></i>
                    <label>Correo</label>
                    <input
                        className={`${classNameInput} caret-input`}
                        defaultValue={usuario.mail}
                        onChange={(e) => editarValorUsuario("correoActual", e.target.value)}
                        disabled
                    />
                    <i class="fa-regular fa-address-card"></i>
                    <label>DNI</label>
                    <input
                        className={`${classNameInput} caret-input`}
                        defaultValue={usuario.dni||''}
                        onChange={(e) => editarValorUsuario("numDocumento", e.target.value)}
                        disabled
                    />
                    <i className="fas fa-phone"></i>
                    <label>Telefono</label>
                    <input
                        className={`${classNameInput} caret-input`}
                        onKeyPress={(e) => soloCelular(e,e.target)}
                        defaultValue={usuario.telephoneNumber}
                        onChange={(e) => editarValorAmonestacion("telefonoActual", e.target.value)}
                        disabled
                    />
                </div>
            </Modal>
            
            <ModalRecarga 
                isOpen={isOpenModalBloqueos} closeModal={closeModalBloqueos} actionRecargar={registrarUsuarioEstado} actionDenegar={{}}
                title= 'Verificar Bloqueo'
                spinner={spinner}
                textButtons = { {confirm: 'SI', denied: 'NO',cancel:'Cancelar'}}

                >
                <div className="flex gap-8 items-center flex-wrap justify-center">
                    <div className="w-[550px] px-4">
                        <div className="flex flex-col justify-between w-full form-content">
                            <div className='lg:flex-col flex-col lg:w-full' >
                                <label className='mb-[10px] w-full'>Solicitudes de Bloqueos:</label>
                                {/* <input  autoFocus={true} className={`${classNameInput} caret-input h-[80px] w-[500px] text-[15px]`} defaultValue={usuario.motivoCambioEstado} onChange={(e) => {editarValorUsuario("motivoCambioEstado", e.target.value)}} > */}
                                <table className="table w-full">
                                    <thead>
                                        <tr>
                                            <th className="w-[40px]">N</th>
                                            <th className="">COMENTARIO</th>
                                            <th className="">USUARIO</th>
                                            <th className="">FECHA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   
                                            bloqueos.length > 0 
                                            ? bloqueos.map((b, i) => {
                                                const FechaHoraInicio = b.fechaHoraInicio.split('T')[0] + ' ' + b.fechaHoraInicio.split('T')[1].split('.')[0]
                                                return (
                                                    <tr key={b.codUsuarioOAuth}>
                                                        <td>{++i}</td>
                                                        <td className="text-center">{b.motivoCreacion}</td>
                                                        <td className="text-center">{b.nomUsuario}</td>
                                                        <td className="text-center">{FechaHoraInicio}</td>
                                                    </tr>
                                                )
                                            })
                                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>

                            <div className='lg:flex-col flex-col lg:w-full mt-5'>
                                    <label className='mb-[10px] w-full'>Ingrese un comentario para el cambio de estado:  </label>
                                    <div className="flex items-center gap-4 w-full">
                                        <textarea autoFocus={true} className={`${classNameInput} caret-input h-[70px] w-full text-[15px] py-3`} defaultValue={amonestacion.motivoCreacion} onChange={(e) => editarValorAmonestacion("motivoCreacion", e.target.value)} />
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </ModalRecarga>   
                

            <Modal 
                isOpen={isOpenModalAmonestaciones} closeModal={closeModalAmonestaciones} action={{}}
                title= {"Historial de Amonestaciones"}
                spinner={spinner}
                textButtons={{ confirm: '', denied:'Cerrar'}}
                validButton ={{confirm: false, denied: true}}
                >
                <>
                <div className="containerScroll  max-h-[300px] mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table className="table">
                        <thead>
                            <tr>
                                <th>N</th>
                                <th>DESCRIPCION</th>
                                <th>TIPO</th>
                                <th>USUARIO</th>
                                <th>FECHA CREACION</th>
                                <th>FECHA VENCIMIENTO</th>
                                {/* <th>VAUCHER</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {   
                                amonestaciones.length > 0 
                                ?
                                amonestaciones.map((a, i) => {
                                    const fechaInicio = a.fechaHoraInicio.split('T')[0] + ' ' + a.fechaHoraInicio.split('T')[1].split('.')[0]
                                    const fechaFin = a.fechaHoraFin.split('T')[0] + ' ' + a.fechaHoraFin.split('T')[1].split('.')[0]
                                    return (
                                        <tr key={a.codUsuarioEstado}>
                                            <td>{++i}</td>
                                            <td>{a.motivoCreacion}</td>
                                            <td className="text-center">{a.nomUsuarioEstadoTipo}</td>
                                            <td className="text-center">{a.nomPersonaCreacion}</td>
                                            <td className="text-center">{fechaInicio}</td>
                                            <td className="text-center">{fechaFin}</td>      
                                            {/* <td className="text-center">{a.codPeticion}</td>       */}
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                </table>
                </div>
                </>                
            </Modal> 

            <Modal
                title={`Anular [ ${usuarioAnular.nomUsuarioAnular} ]`}
                isOpen={isOpenModalAnularUsuario}
                closeModal={closeModalAnularUsuario}
                action={() => registrarAnularUsuario()}
                textButtons={{ confirm: 'Si', denied:'No'}}
                validButton={{confirm: true, denied: true}}
            >
                <div className='flex flex-col items-center gap-2 py-3 w-[450px]'>
                    <img
                        src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                        className='w-[40px] h-[40px]'
                        alt=''
                    />
                    <span className='text-lg'>¿Está seguro de realizar la operación ?</span>
                    <span className='float-left w-full'>Motivo:</span>
                    <textarea
                        className={classNameInput + ' h-[80px] caret-white py-2'}
                        value={usuarioAnular.motivoAnular}
                        onChange={(e) => editarValorAnularUsuario("motivoAnular", e.target.value)}
                    ></textarea>
                </div>
            </Modal> 
        </>
    )
}